import LoginIcon from '@material-ui/icons/ExitToApp'
import LogoutIcon from '@material-ui/icons/PowerSettingsNew'
import HomeIcon from '@material-ui/icons/Home'
import ContentIcon from '@material-ui/icons/Inbox'
import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import MenuIcon from '@material-ui/icons/Menu'
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Dashboard from '@material-ui/icons/Dashboard'
import CloseIcon from '@material-ui/icons/Close'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/Warning'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import ViewIcon from '@material-ui/icons/Visibility'
import PersonIcon from '@material-ui/icons/Person'
import PeopleIcon from '@material-ui/icons/People'
import BuildIcon from '@material-ui/icons/Build'
import WidgetsIcon from '@material-ui/icons/Widgets'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import FaceIcon from '@material-ui/icons/Face'
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes'
import FolderIcon from '@material-ui/icons/Folder'
import ForwardIcon from '@material-ui/icons/Forward'
import FilterListIcon from '@material-ui/icons/FilterList'
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumberedRtl'
import ListIcon from '@material-ui/icons/List'
import SaveIcon from '@material-ui/icons/Save'
import ExpandIcon from '@material-ui/icons/KeyboardArrowDown'
import ContractIcon from '@material-ui/icons/KeyboardArrowUp'
import ClosedIcon from '@material-ui/icons/ChevronRight'
import UploadIcon from '@material-ui/icons/CloudUpload'
import SettingsIcon from '@material-ui/icons/Settings'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import PaymentIcon from '@material-ui/icons/Payment'

const icons = {
  payment: PaymentIcon,
  pdf: PictureAsPdfIcon,
  settings: SettingsIcon,
  login: LoginIcon,
  logout: LogoutIcon,
  upload: UploadIcon,
  home: HomeIcon,
  project: ContentIcon,
  add: AddIcon,
  edit: EditIcon,
  delete: DeleteIcon,
  more: MoreVertIcon,
  menu: MenuIcon,
  drag: UnfoldMoreIcon,
  account: AccountCircle,
  preview: Dashboard,
  close: CloseIcon,
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
  view: ViewIcon,
  template: FormatListNumberedIcon,
  labour: PersonIcon,
  materials: BuildIcon,
  hire: LocalShippingIcon,
  waste: DeleteIcon,
  misc: WidgetsIcon,
  security: WidgetsIcon,
  access: WidgetsIcon,
  terrain: WidgetsIcon,
  storage: WidgetsIcon,
  team: PeopleIcon,
  client: FaceIcon,
  quote: SpeakerNotesIcon,
  folder: FolderIcon,
  forward: ForwardIcon,
  total: FilterListIcon,
  task: ListIcon,
  save: SaveIcon,
  expand: ExpandIcon,
  contract: ContractIcon,
  closed: ClosedIcon,
}

export default icons